// Recovered from static/main.7bd2eca3bac83dc8.chunk.js, module 98991, offsets 505888:506274. Structure and names inferred from code, not screenshots.

let n = "u" > typeof window;
(n && window.localStorage, n && window.sessionStorage);
let o = {
    analytical: true,
    functional: true,
    valid: false,
  },
  a = new Set();
function getCookiePreferences() {
  return o;
}
function setCookiePreferences(e) {
  for (let t of ((o = e), a)) t();
}
function subscribePreferences(e) {
  return (
    a.add(e),
    () => {
      a.delete(e);
    }
  );
}
function trackPreferenceChange(e, t) {}
export {
  getCookiePreferences,
  trackPreferenceChange,
  setCookiePreferences,
  subscribePreferences,
};
